function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useContext } from 'react';
import { buildClassNames } from '../../../modules/css-helpers';
import { createOwnUpComponent } from '../../components';
import { isHeaderContext, useTableProps } from './context';
import { OwnUpTableCellStyle, OwnUpTableHeaderCellStyle } from './style';
/**
 * th
 */

var StyledTableHeaderCell = createOwnUpComponent('th', OwnUpTableHeaderCellStyle);

var HeaderCellImpl = function HeaderCellImpl(_ref) {
  var classNames = _ref.classNames,
      variant = _ref.variant,
      props = _objectWithoutProperties(_ref, ["classNames", "variant"]);

  var classes = buildClassNames.apply(void 0, ['ou-table__th'].concat(_toConsumableArray(classNames)));
  return /*#__PURE__*/React.createElement(StyledTableHeaderCell, _extends({
    className: classes,
    variant: variant
  }, props));
};
/**
 * td
 */


var StyledTableCell = createOwnUpComponent('td', OwnUpTableCellStyle);

var CellImpl = function CellImpl(_ref2) {
  var classNames = _ref2.classNames,
      variant = _ref2.variant,
      props = _objectWithoutProperties(_ref2, ["classNames", "variant"]);

  var classes = buildClassNames.apply(void 0, ['ou-table__td'].concat(_toConsumableArray(classNames)));
  return /*#__PURE__*/React.createElement(StyledTableCell, _extends({
    className: classes,
    variant: variant
  }, props));
};

export var isTableCell = function isTableCell(node) {
  return _typeof(node) === 'object' && node !== null && 'type' in node && node.type === OwnUpTableCell;
};
/**
 * Creates an Own Up-themed Table Cell
 *
 * This cell will either be a th or td element based on the place it is used in the Table.
 *   Additionally variants and class names will be inherited from the Table
 *   If you do not need to attach classnames, variants, or other properties to the cell itself
 *   consider instead just passing the element you would include as a child into the
 *   data array of the table or row.
 *
 * @param props - Properties that dictate the Cell.
 */

export var OwnUpTableCell = function OwnUpTableCell(_ref3) {
  var className = _ref3.className,
      variant = _ref3.variant,
      props = _objectWithoutProperties(_ref3, ["className", "variant"]);

  // Extract the subset of shared properties that will be given
  //   to each element in the table. This includes variants and
  //   classes.
  var context = useTableProps(className, variant);
  var header = useContext(isHeaderContext);

  if (header) {
    return /*#__PURE__*/React.createElement(HeaderCellImpl, _extends({
      variant: context.variant,
      classNames: context.classNames
    }, props));
  } else {
    return /*#__PURE__*/React.createElement(CellImpl, _extends({
      variant: context.variant,
      classNames: context.classNames
    }, props));
  }
};